<footer class="footer">
    <div class="footer-inner">

        <div class="footer-contact">
            <p class="footer-title">{{ 'footer.contact.title' | translate }}</p>
            <p class="footer-subtitle">{{ 'footer.contact.subtitle' | translate }}</p>

            <ul class="contact-list">
                <li>
                    <a href="https://wa.me/34644723402" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp +34 644 723 402">
                        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.56.93.95-3.47-.22-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.23-9.43 9.43-9.43a9.37 9.37 0 0 1 6.67 2.77 9.36 9.36 0 0 1 2.76 6.67c0 5.2-4.23 9.42-9.44 9.42zm8.02-17.45A11.27 11.27 0 0 0 12.05.72C5.8.72.72 5.8.72 12.05c0 2 .52 3.95 1.52 5.66L.62 23.62l6.05-1.59a11.3 11.3 0 0 0 5.38 1.37h.01c6.24 0 11.33-5.08 11.33-11.33 0-3.03-1.18-5.87-3.32-8.02z"/></svg>
                        <span>+34 644 723 402</span>
                    </a>
                </li>
                <li>
                    <a href="mailto:hola@conectio.io">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/></svg>
                        <span>hola&#64;conectio.io</span>
                    </a>
                </li>
                <li>
                    <span class="contact-static">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                        <span>Manuel de Falla 13, Barcelona, Spain</span>
                    </span>
                </li>
                <li>
                    <a href="https://www.linkedin.com/company/conectiodigital/" target="_blank" rel="noopener">
                        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z"/></svg>
                        <span>{{ 'footer.contact.linkedin' | translate }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="footer-bottom">
            <a href="https://conectio.io" class="footer-logo">
                <img src="assets/conectio-logo-white.png" alt="Conectio" width="800" height="224" loading="lazy">
            </a>
            <div class="footer-copyright">
                <span>Copyright © {{ year }} Conectio.</span>
                <span>{{ 'footer.rights' | translate }}</span>
            </div>
            <nav class="legal-links" [attr.aria-label]="'footer.legal.label' | translate">
                <a [href]="('footer.siteBase' | translate) + '/legal-advise'" rel="nofollow">{{ 'footer.legal.legalNotice' | translate }}</a>
                <a [href]="('footer.siteBase' | translate) + '/cookie-policy'" rel="nofollow">{{ 'footer.legal.cookiePolicy' | translate }}</a>
                <a [href]="('footer.siteBase' | translate) + '/privacy-policy'" rel="nofollow">{{ 'footer.legal.privacyPolicy' | translate }}</a>
            </nav>
        </div>
    </div>
</footer>
